import React, { useMemo } from 'react';
import '../Style/ReactionSocialProof.css';

const REACTION_EMOJIS = {
  FIRE: '🔥',
  STRONG: '💪',
  STAR: '⭐',
  HEART: '❤️',
};

const REACTION_ORDER = ['FIRE', 'STRONG', 'STAR', 'HEART'];

const ReactionSocialProof = ({ reactionUsers = [], onOpen }) => {
  const summary = useMemo(() => {
    if (!reactionUsers.length) return null;

    const uniqueTypes = new Set();

    reactionUsers.forEach((user) => {
      user.reactionTypes?.forEach((type) => uniqueTypes.add(type));
    });

    const emojis = REACTION_ORDER.filter((type) => uniqueTypes.has(type))
      .map((type) => REACTION_EMOJIS[type])
      .join(' ');

    const names = reactionUsers.map((user) => user.firstName).filter(Boolean);

    return {
      emojis,
      names,
      othersCount: Math.max(0, names.length - 2),
    };
  }, [reactionUsers]);

  if (!summary) return null;

  return (
    <button
      type="button"
      className="reaction-social-proof"
      onClick={(e) => {
        e.stopPropagation();
        if (onOpen) onOpen(reactionUsers);
      }}
    >
      <span className="reaction-proof-emojis">{summary.emojis}</span>

      {summary.names.length === 1 && (
        <>
          <span className="reaction-proof-name">{summary.names[0]}</span>
          <span> reacted</span>
        </>
      )}

      {summary.names.length === 2 && (
        <>
          <span className="reaction-proof-name">{summary.names[0]}</span>
          <span> and </span>
          <span className="reaction-proof-name">{summary.names[1]}</span>
          <span> reacted</span>
        </>
      )}

      {summary.names.length > 2 && (
        <>
          <span className="reaction-proof-name">{summary.names[0]}</span>
          <span>, </span>
          <span className="reaction-proof-name">{summary.names[1]}</span>
          <span> and {summary.othersCount} others reacted</span>
        </>
      )}
    </button>
  );
};

export default ReactionSocialProof;
